import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { IDocumentSearchManagedProperty, IUserConfigPackage } from '../../../API';
import ReusableDialog, { IReusableDialogFooterProps, ReusableDialogState } from '../../controls/ReusableDialog';
import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';
import { Stack, TextField } from '@fluentui/react';
import { useEffect } from 'react';

export class ManagedPropertyEditorState implements IDocumentSearchManagedProperty {
	public userConfig: IUserConfigPackage;

	public dialog:ReusableDialogState;

	public Id: string = '';
	public Title: string = '';
	public InternalName: string = '';

	//Unused
	//-------------
	public DisplayTitle: string = '';
	public ServerRelativeUrl: string = '';
	public NativeMetadataUrl: string = '';
	original: IDocumentSearchManagedProperty = {} as IDocumentSearchManagedProperty;
	//-------------

	private thisItem() : IDocumentSearchManagedProperty {
		return {
			Id: this.Id,
			InternalName: this.InternalName,
			Title: this.Title,
			DisplayTitle: this.DisplayTitle,
			ServerRelativeUrl: this.ServerRelativeUrl,
			NativeMetadataUrl: this.NativeMetadataUrl,
		};
	}


	public dialogButtons: IReusableDialogFooterProps = {
		leftButtons: [/*
			{
				text: 'Delete',
				iconProps: {iconName: 'Delete'},
				onClick: (ev) => {
					this.dialog.onDismiss();
					this.onDelete(this.original);
				},
			}
		*/],
		rightButtons: [
			{
				text: 'Cancel',
				onClick: (ev) => {
					this.dialog.onDismiss();
				},
			},
			{
				text: 'Save',
				onClick: (ev) => {
					this.dialog.onDismiss();
					this.onSave(this.original, this.thisItem());
				},
			}
		],
	};

	onSave: (original:IDocumentSearchManagedProperty, updated:IDocumentSearchManagedProperty) => void;
	onDelete: (profile:IDocumentSearchManagedProperty) => void;

	constructor(
		userConfig: IUserConfigPackage,
		onDelete: (profile:IDocumentSearchManagedProperty) => void,
		onSave: (original:IDocumentSearchManagedProperty, updated:IDocumentSearchManagedProperty) => void
	) {
		this.userConfig = userConfig;
		this.onDelete = onDelete;
		this.onSave = onSave;
		
		this.dialog = new ReusableDialogState("Search Managed Property", 500);

		makeAutoObservable(this);
	}

	public setItem(item:IDocumentSearchManagedProperty) {
		this.original = item;
		Object.assign(this, item);
	}
	
	public setTitle(val:string) {
		this.Title = val;
	}

	public setInternalName(val:string) {
		this.InternalName = val;
	}
	
	public async ensureInitialLoaded() : Promise<void> {
		
	}
}

function ManagedPropertyEditor({
	state
}: {
	state: ManagedPropertyEditorState
}) {

	useEffect(() => {
		state.ensureInitialLoaded();
	}, [state]);
	
	return (

		<ReusableDialog state={state.dialog} footerButtons={state.dialogButtons}>
			
			<Stack>

				<InfoTooltipLabel label='Title' title='Managed property title'>
				
					<TextField defaultValue={state.Title} onChange={(_, v) => { state.setTitle(v || '') }} />
					
				</InfoTooltipLabel>

				<InfoTooltipLabel label='Internal Name' title='Managed property internal name'>

					<TextField defaultValue={state.InternalName} onChange={(_, v) => { state.setInternalName(v || '') }} />

				</InfoTooltipLabel>

			</Stack>
		</ReusableDialog>
	);
}

export default observer(ManagedPropertyEditor);
